import { Typography } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { authToken } from 'features/users/stores/userSlice'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

const TokenAuth = () => {
  const dispatch = useDispatch()

  const [searchParams, setSearchParams] = useSearchParams()

  const tokenLogin = async (token, to) => {
    localStorage.clear()
    sessionStorage.clear()
    await dispatch(authToken({ token })).unwrap()

    window.location.href += `${to}`
  }

  useEffect(() => {
    const token = searchParams?.get('jwt')
    const to = searchParams?.get('to')
    tokenLogin(token, to)
  }, [searchParams])

  return (
    <Backdrop
      sx={{
        flexDirection: 'column',
        gap: '20px',
        zIndex: '999999',
      }}
      open={true}
    >
      <CircularProgress color="inherit" />
      <Typography>Autentificando usuario</Typography>
    </Backdrop>
  )
}

export default TokenAuth
